import { v4 as uuidV4 } from "uuid";
import Vue from "vue";
import EventLogicActionsList from "@/EventLogic/components/EventLogicActionsList.vue";
import EventLogicConditionsList from "@/EventLogic/components/EventLogicConditionsList.vue";

export default class Feedback {
  constructor(scenarios) {
    this.originalScenarios = scenarios;
    this.scenarios = this.deepClone(scenarios);
  }

  deepClone(scenarios) {
    return JSON.parse(JSON.stringify(scenarios));
  }

  getComponent(name) {
    return EventLogicActionsList.components[name]
      || EventLogicConditionsList.components[name];
  }

  isModified() {
    return JSON.stringify(this.scenarios) !== JSON.stringify(this.originalScenarios);
  }

  prepareScenarios() {
    // return;

    // The UI should always have at least one logicset, and each logicset should have at least one
    // if/then/otherwise.
    // (Though initially they'll be 'empty' with just a dropdown to select the action/condition
    // type).
    //
    // When we serialize (i.e. in the cleanupScenarios filter) we remove those empty objects.
    if (!this.scenarios || this.scenarios.length === 0) {
      this.addScenario();
    }
    this.scenarios.forEach(scenario => {
      if (!scenario.name) {
        Vue.set(scenario, 'name', '');
      }
      if (!scenario.id) {
        Vue.set(scenario, 'id', uuidV4());
      }
      if (!scenario.conditions || scenario.conditions.length === 0) {
        this.addCondition(scenario);
      }
      if (!scenario.then || scenario.then.length === 0) {
        this.addAction(scenario, 'then');
      }
      if (!scenario.otherwise || scenario.otherwise.length === 0) {
        this.addAction(scenario, 'otherwise');
      }
    });
  }

  addScenario() {
    if (!this.scenarios) {
      this.scenarios = [];
    }
    this.scenarios.push({
      conditionmodifier: 'all',
      numquestions: 1,
      name: '',
      id: uuidV4(),
      conditions: [],
      then: [],
      otherwise: []
    });
  }

  copyScenario(idx) {
    const newScenario = this.deepClone(this.scenarios[idx]);
    newScenario.name += ' (Copy)';
    newScenario.id = uuidV4();
    newScenario.conditions.forEach(condition => condition.id = uuidV4());
    const updateActionIds = action => {
      action.id = uuidV4();
      if (action.incentivetype === 'message') {
        action.message.forEach(message => message.id = uuidV4());
      }
    };
    newScenario.then.forEach(updateActionIds);
    newScenario.otherwise.forEach(updateActionIds);
    this.scenarios.splice(idx + 1, 0, newScenario);
  }

  removeScenario(idx) {
    this.scenarios.splice(idx, 1);
  }

  addAction(scenario, location, after) {
    if (!scenario[location]) {
      scenario[location] = [];
    }
    scenario[location].splice(after + 1, 0, {id: uuidV4(), incentivetype: ''});
  }

  addCondition(scenario, after) {
    if (!scenario.conditions) {
      scenario.conditions = [];
    }
    scenario.conditions.splice(after + 1, 0, {id: uuidV4(), type: ''});
  }

  cleanupScenarios() {
    // return scenarios;
    let tmp = JSON.parse(JSON.stringify(this.scenarios));

    tmp.forEach(scenario => {
      // Get rid of conditions with no type
      scenario.conditions = scenario.conditions.filter(function (condition) {
        return !!condition.type;
      });

      // The condition may only store what it has as props on its component,
      // plus the condition type
      scenario.conditions.forEach(condition => {
        if (this.getComponent(condition.type)) {
          const props = this.getComponent(condition.type).props || {};
          const acceptableKeys = Object.keys(props).concat('type');

          Object.keys(condition).forEach(key => {
            if (acceptableKeys.indexOf(key) === -1) {
              delete condition[key];
            }
          });
        }
      });

      ['then', 'otherwise'].forEach(section => {
        // Get rid of actions with no type
        scenario[section] = scenario[section].filter(action => !!action.incentivetype);

        // An action may only store what it has as props on its component, plus the incentivetype
        scenario[section].forEach(action => {
          if (this.getComponent(action.incentivetype)) {
            const props = this.getComponent(action.incentivetype).props || {};

            const acceptableKeys = Object.keys(props).concat('incentivetype');

            Object.keys(action).forEach(function (key) {
              if (acceptableKeys.indexOf(key) === -1) {
                delete action[key];
              }
            });
          }
        });
      });
    });

    // Remove empty scenarios
    tmp = tmp.filter(scenario => {
      return (scenario.then.length > 0
        || scenario.otherwise.length > 0
        || scenario.conditions.length > 0
        || scenario.name.length > 0);
    });
    return tmp;
  }

  setupReactiveProps() {
    // Make sure each thing has the reactive props that it needs
    this.scenarios.forEach(scenario => {
      scenario.conditions.forEach(condition => {
        this.updateConditionProps(condition);
      });
      scenario.then.forEach(action => {
        this.updateActionProps(action);
      });
      scenario.otherwise.forEach(action => {
        this.updateActionProps(action);
      });
    });
  }

  updateConditionProps(condition) {
    if (!condition.type) {
      // there's no condition type and thus no component to get props from
      return;
    }
    this.updateComponentProps(condition, this.getComponent(condition.type));
  }

  updateActionProps(action) {
    if (!action.incentivetype) {
      // there's no action type and thus no component to get props from
      return;
    }
    // debugger;
    this.updateComponentProps(action, this.getComponent(action.incentivetype));
  }

  updateComponentProps(object, component) {
    const props = component.props || {};
    Object.keys(props).forEach(prop => {
      if (object.hasOwnProperty(prop)) {
        return;
      }
      let newValue = props[prop].hasOwnProperty('default') ? props[prop].default : null;
      if (typeof newValue === 'function') {
        newValue = newValue();
      }
      Vue.set(
        object,
        prop,
        newValue
      );
    });

  }
}
